import { Injectable } from '@angular/core';
import { UrlBuilderService } from '../services/url-builder-service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BuildConfig } from '../model/build-config';
import { Build } from '../model/build';
import { BuildLog } from '../model/build-log';
import { BuildArtifact } from '../model/build-artifact';

@Injectable({
  providedIn: 'root'
})
export class BuildsService {

  constructor(
    private urlBuilder: UrlBuilderService,
    private http: HttpClient) {
  }

  public getBuilds(config: BuildConfig): Observable<Build[]> {
    return this.http.get<Build[]>(this.urlBuilder.buildUrl('/build-configs/{configId}/builds',
      {configId: config.id.toString()}));
  }

  public getBuild(config: BuildConfig, id: number): Observable<Build> {
    return this.http.get<Build>(this.urlBuilder.buildUrl('/build-configs/{configId}/build/{buildId}',
      {configId: config.id.toString(), buildId: id.toString()}));
  }

  public addBuild(config: BuildConfig, release: string): Observable<Build> {
    return this.http.post<Build>(this.urlBuilder.buildUrl('/build-configs/{configId}/builds',
      {configId: config.id.toString()}), release);
  }

  public getLogs(build: Build): Observable<BuildLog[]> {
    return this.http.get<BuildLog[]>(this.urlBuilder.buildUrl('/build-configs/{configId}/builds/{buildId}/logs',
      {configId: build.config.id.toString(), buildId: build.id.toString()}));
  }

  public getArtifacts(build: Build): Observable<BuildArtifact[]> {
    return this.http.get<BuildArtifact[]>(this.urlBuilder.buildUrl('/build-configs/{configId}/builds/{buildId}/artifacts',
      {configId: build.config.id.toString(), buildId: build.id.toString()}));
  }

  public getReleaseNotes(build: Build) {
    return this.http.get(this.urlBuilder.buildUrl('/build-configs/{configId}/builds/{buildId}/release-notes',
      {configId: build.config.id.toString(), buildId: build.id.toString()}),
      {responseType: 'blob' as 'json', observe: 'events', reportProgress: true});
  }

  public emailReleaseNotes(build: Build, config) {
    return this.http.post(this.urlBuilder.buildUrl('/build-configs/{configId}/builds/{buildId}/release-notes/email',
      {configId: build.config.id.toString(), buildId: build.id.toString()}), {
        mailTo: config.email,
        subject: config.subject
      },
      {responseType: 'blob' as 'json', observe: 'events', reportProgress: true});
  }

  public publish(build: Build): Observable<void> {
    return this.http.post<void>(this.urlBuilder.buildUrl('/build-configs/{configId}/builds/{buildId}/publish',
      {configId: build.config.id.toString(), buildId: build.id.toString()}), {});
  }

  public unpublish(build: Build): Observable<void> {
    return this.http.post<void>(this.urlBuilder.buildUrl('/build-configs/{configId}/builds/{buildId}/unpublish',
      {configId: build.config.id.toString(), buildId: build.id.toString()}), {});
  }

  public downloadArtifact(build: Build, artifact: BuildArtifact) {
    return this.http.get(this.urlBuilder.buildUrl('/build-configs/{configId}/builds/{buildId}/artifacts/{artifactName}',
      {configId: build.config.id.toString(), buildId: build.id.toString(), artifactName: artifact.name}),
      {responseType: 'blob' as 'json', observe: 'events', reportProgress: true});
  }
}
